<h1 class="form-title">
  {{ 'active.user.title' | translate }}
</h1>
